import { useState } from "react";
import { useForm } from "react-hook-form";
import { Input, Button, PageHeader, Textarea, FormField, PageLayout, useToast } from "@dawa/ui";
import { apiFetch } from "../lib/api";

type FormValues = { email: string; message: string };

export default function Contact() {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    reset,
  } = useForm<FormValues>();
  const { addToast, Toasts } = useToast();
  const [submitError, setSubmitError] = useState<string | null>(null);

  const onSubmit = async ({ email, message }: FormValues) => {
    setSubmitError(null);
    try {
      const res = await apiFetch("/support/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ source: "contact", email, message }),
      });
      if (!res.ok) {
        let details = "Impossible d'envoyer le message.";
        try {
          const body = (await res.json()) as { details?: string };
          if (body?.details) details = body.details;
        } catch {
          // ignore body parse errors
        }
        throw new Error(details);
      }
      addToast("Message envoye. Nous revenons vers vous sous 24h ouvrees.", "success");
      reset();
    } catch (err) {
      const details = err instanceof Error ? err.message : "Impossible d'envoyer le message.";
      setSubmitError(details);
      addToast(details, "error");
    }
  };

  return (
    <PageLayout maxWidth="full">
      <form className="space-y-4" onSubmit={handleSubmit(onSubmit)}>
        <PageHeader title="Contact" subtitle="Envoyez-nous un message, nous répondons sous 24h ouvrées." />
        <FormField label="Email" htmlFor="email" required error={errors.email?.message as string | undefined}>
          <Input
            id="email"
            placeholder="Votre email"
            type="email"
            autoComplete="email"
            required
            hasError={!!errors.email}
            {...register("email", {
              required: "Email requis",
              pattern: { value: /.+@.+\..+/, message: "Email invalide" },
            })}
          />
        </FormField>
        <FormField label="Message" htmlFor="message" required error={errors.message?.message as string | undefined}>
          <Textarea
            id="message"
            placeholder="Votre message"
            required
            rows={6}
            hasError={!!errors.message}
            {...register("message", {
              required: "Message requis",
              minLength: { value: 5, message: "Message trop court" },
            })}
          />
        </FormField>
        {submitError && <p className="text-sm text-danger">{submitError}</p>}
        <Button type="submit" disabled={isSubmitting}>
          Envoyer
        </Button>
      </form>
      <Toasts />
    </PageLayout>
  );
}
